(function () {
  'use strict';

  // Overlay CSS — inner panel reuses .jn-bsm styles (shared with bra modal)
  const OVERLAY_CSS = `.jn-psm-overlay{position:fixed;inset:0;background:rgba(26,23,20,.52);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .28s ease}.jn-psm-overlay.open{opacity:1}@media(max-width:600px){.jn-psm-overlay{align-items:flex-start}}dialog.jn-psm-overlay{padding:0;border:none;margin:0;width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;overflow:hidden}dialog.jn-psm-overlay::backdrop{display:none}`;

  // Full inner-panel CSS — copy of bra modal .jn-bsm styles, injected if bra modal hasn't run yet
  const PANEL_CSS = `.jn-bsm{--dark:#1A1714;--mid:#3D3730;--gold:#8B6F4E;--lgold:#C4A882;--beige:#EDE5D8;--lbeige:#F3EDE4;--border:#E2D9CC;--muted:#8A8178;--warm-white:#FDFBF8;--cream:#F8F4EE;font-family:'Inter',sans-serif;-webkit-font-smoothing:antialiased;background:var(--cream);color:var(--dark);position:relative;overflow-y:auto;width:100%;max-width:800px;max-height:90vh}@media(max-width:600px){.jn-bsm{max-width:100%;max-height:100dvh;height:100dvh}}.jn-bsm *,.jn-bsm *::before,.jn-bsm *::after{box-sizing:border-box;margin:0;padding:0}.jn-bsm-close{position:absolute;top:16px;right:18px;z-index:10;background:none;border:none;cursor:pointer;font-size:20px;color:var(--muted);line-height:1;padding:6px;transition:color .2s;font-family:sans-serif}.jn-bsm-close:hover{color:var(--dark)}.jn-bsm-prog{position:absolute;top:0;left:0;height:2px;background:var(--dark);transition:width .4s ease;z-index:10}.jn-bsm .screen{opacity:0;transform:translateY(10px);transition:opacity .3s ease,transform .3s ease}.jn-bsm .screen.active{opacity:1;transform:none}.jn-bsm .qlabel{font-family:'Inter',sans-serif;font-size:10px;letter-spacing:.22em;text-transform:uppercase;color:var(--gold);margin-bottom:14px;display:block}.jn-bsm .qtitle{font-family:'Cormorant Garamond',serif;font-size:clamp(26px,4vw,42px);font-weight:400;line-height:1.15}.jn-bsm .qsub{font-size:14px;font-weight:300;color:var(--muted);margin-top:10px;line-height:1.7}.jn-bsm .btn{display:inline-flex;align-items:center;gap:10px;font-family:'Inter',sans-serif;font-size:11px;font-weight:500;letter-spacing:.15em;text-transform:uppercase;border:none;cursor:pointer;transition:all .22s ease}.jn-bsm .btn-d{padding:14px 36px;background:var(--dark);color:var(--warm-white)}.jn-bsm .btn-d:hover{background:var(--mid)}.jn-bsm .btn-d:disabled{opacity:.35;cursor:not-allowed}.jn-bsm .btn-g{padding:12px 22px;background:transparent;color:var(--muted);border:1.5px solid var(--border)}.jn-bsm .btn-g:hover{color:var(--dark);border-color:var(--dark)}.jn-bsm .qnav{display:flex;align-items:center;justify-content:center;gap:14px;margin-top:40px;flex-wrap:wrap}.jn-bsm .fside-l .qnav{justify-content:flex-start}@media(max-width:600px){.jn-bsm .fside-l .qnav{justify-content:center}}.jn-bsm .qwrap{padding:44px 36px 52px}.jn-bsm .qhead{text-align:center;margin-bottom:36px}.jn-bsm .sgrid{display:grid;grid-template-columns:1fr 1fr;gap:16px;max-width:600px;margin:0 auto}@media(max-width:500px){.jn-bsm .sgrid{grid-template-columns:1fr}}.jn-bsm .scard{padding:32px 18px;background:white;border:1.5px solid var(--border);cursor:pointer;text-align:center;transition:border-color .22s,background .22s,transform .22s}.jn-bsm .scard:hover,.jn-bsm .scard.sel{border-color:var(--dark);background:var(--lbeige)}.jn-bsm .scard-icon{font-size:24px;margin-bottom:10px}.jn-bsm .scard-title{font-family:'Cormorant Garamond',serif;font-size:19px;font-weight:400;margin-bottom:6px}.jn-bsm .scard-desc{font-size:12px;color:var(--muted);line-height:1.6}.jn-bsm .fwrap{padding:44px 36px 52px;text-align:center}.jn-bsm .fpage{padding:40px 36px 52px;display:grid;grid-template-columns:1fr 1fr;gap:48px;align-items:center}@media(max-width:600px){.jn-bsm .fpage{grid-template-columns:1fr;gap:0;padding:32px 20px 44px}}.jn-bsm .fside-l{display:flex;flex-direction:column;align-items:flex-start}@media(max-width:600px){.jn-bsm .fside-l{order:2;padding-top:28px;align-items:center;text-align:center}}@media(max-width:600px){.jn-bsm .fside-r{order:1}}.jn-bsm .fimg-wrap{position:relative;width:100%;height:420px;background:var(--lbeige)}.jn-bsm .fillus{display:block;width:100%;height:100%;object-fit:contain;object-position:center center}@media(max-width:600px){.jn-bsm .fimg-wrap{height:240px}}.jn-bsm .fimg-cap{position:absolute;bottom:0;left:0;right:0;background:rgba(26,23,20,.62);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);padding:14px 18px 16px;border-top:1px solid rgba(255,255,255,.12)}.jn-bsm .fimg-cap-label{font-family:'Inter',sans-serif;font-size:9px;letter-spacing:.24em;text-transform:uppercase;color:rgba(196,168,130,.85);margin-bottom:6px}.jn-bsm .fimg-cap-quote{font-family:'Cormorant Garamond',serif;font-size:14px;font-style:italic;font-weight:400;line-height:1.6;color:rgba(255,255,255,.9)}.jn-bsm .utog{display:flex;justify-content:flex-start;margin:32px 0 8px}@media(max-width:600px){.jn-bsm .utog{justify-content:center}}.jn-bsm .ubtn{padding:7px 20px;border:1.5px solid var(--border);background:white;font-size:11px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;transition:all .2s;font-family:'Inter',sans-serif;color:var(--muted)}.jn-bsm .ubtn:first-child{border-right:none}.jn-bsm .ubtn.on{background:var(--dark);color:white;border-color:var(--dark)}.jn-bsm .minp-g{margin:8px 0 0;width:100%;max-width:240px}@media(max-width:600px){.jn-bsm .minp-g{margin:8px auto 0}}.jn-bsm .minp-l{font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:var(--muted);margin-bottom:8px;display:block;font-family:'Inter',sans-serif}.jn-bsm .minp{width:100%;padding:11px 12px;background:white;border:1.5px solid var(--border);font-family:'Cormorant Garamond',serif;font-size:30px;text-align:center;color:var(--dark);outline:none;transition:border-color .2s;-moz-appearance:textfield}.jn-bsm .minp::-webkit-inner-spin-button,.jn-bsm .minp::-webkit-outer-spin-button{-webkit-appearance:none}.jn-bsm .minp:focus{border-color:var(--dark)}.jn-bsm .munit{font-size:12px;color:var(--muted);margin-top:5px}.jn-bsm .szdisp{font-family:'Cormorant Garamond',serif;font-size:70px;font-weight:300;line-height:1;margin:16px 0 8px}.jn-bsm .szbreak{font-size:13px;color:var(--muted);margin-bottom:16px}.jn-bsm .szbreak strong{color:var(--dark)}.jn-bsm .sislbl{font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:var(--muted);margin-bottom:8px}.jn-bsm .sispills{display:flex;gap:10px;justify-content:center;margin-bottom:22px}.jn-bsm .sispill{padding:5px 15px;border:1px solid var(--border);font-size:14px;color:var(--muted);font-family:'Cormorant Garamond',serif}.jn-bsm .fnote{background:var(--lbeige);border-left:2px solid var(--lgold);padding:14px 18px 16px;margin:20px auto;max-width:420px;text-align:left}.jn-bsm .fnote-label{font-family:'Inter',sans-serif;font-size:9px;letter-spacing:.24em;text-transform:uppercase;color:var(--gold);margin-bottom:7px}.jn-bsm .fnote-quote{font-family:'Cormorant Garamond',serif;font-size:15px;font-style:italic;font-weight:400;line-height:1.65;color:var(--mid)}`;

  // ── SIZING DATA ─────────────────────────────────────────────────────────────
  const DRESS_SIZES = [
    {n:0,waist:24.0,hip:34.5},{n:2,waist:25.0,hip:35.5},{n:4,waist:26.0,hip:36.5},
    {n:6,waist:27.0,hip:37.5},{n:8,waist:28.0,hip:38.5},{n:10,waist:29.0,hip:39.5},
    {n:12,waist:30.5,hip:41.0},{n:14,waist:32.0,hip:42.5},{n:16,waist:33.5,hip:44.0},
    {n:18,waist:35.5,hip:46.0},{n:20,waist:37.5,hip:48.0},{n:22,waist:39.5,hip:50.0}
  ];
  const DRESS_TO_PANTY = {0:'XS',2:'XS',4:'S',6:'S',8:'M',10:'M',12:'L',14:'L',16:'XL',18:'XL',20:'XXL',22:'XXL'};

  // ── STATE ────────────────────────────────────────────────────────────────────
  let S = { screen:'panty_intent', history:['panty_intent'], unit:'in', waistIn:'', hipIn:'', pantySize:null, dressSize:null };

  const PROGRESS = { panty_intent:0, panty_direct:25, panty_waist:30, panty_hip:65, panty_result:100 };

  // ── HELPERS ──────────────────────────────────────────────────────────────────
  function savePantySize(dressSize, pantySize) {
    var val = JSON.stringify({dressSize: dressSize, pantySize: pantySize});
    document.cookie = 'jfq_dress_sz=' + encodeURIComponent(val) + ';max-age=31536000;path=/;SameSite=Lax';
    try { localStorage.setItem('jfq_dress_sz', val); } catch(e) {}
    try {
      var method = dressSize != null ? 'measured' : 'selected';
      if (window._learnq) window._learnq.push(['track', 'Panty Size Set', {dress_size: dressSize, panty_size: pantySize, method: method}]);
    } catch(e) {}
  }

  function calcDressFromWaistHip(waistIn, hipIn) {
    var best = null, bestScore = Infinity;
    DRESS_SIZES.forEach(function(d) {
      var score = Math.abs(d.hip - hipIn) + Math.abs(d.waist - waistIn) * 0.5;
      if (score < bestScore) { bestScore = score; best = d; }
    });
    return best ? best.n : null;
  }

  function getSisterSizes(sz) {
    var order = ['XS','S','M','L','XL','XXL'];
    var i = order.indexOf(sz), out = [];
    if (i > 0) out.push(order[i-1]);
    if (i < order.length-1) out.push(order[i+1]);
    return out;
  }

  function tog(id, on) {
    var el = document.getElementById(id);
    if (!el) return;
    el.disabled = !on;
    el.style.opacity = on ? '1' : '.35';
    el.style.cursor = on ? 'pointer' : 'not-allowed';
  }

  // ── NAVIGATION ───────────────────────────────────────────────────────────────
  function goTo(s) { S.history.push(s); S.screen = s; render(); }
  function goBack() {
    if (S.history.length > 1) { S.history.pop(); S.screen = S.history[S.history.length-1]; render(); }
  }
  function backBtn() {
    return S.history.length > 1
      ? '<button class="btn btn-g" onclick="window.jnPSM.goBack()">&#8592; Back</button>'
      : '';
  }

  // ── SCREENS ──────────────────────────────────────────────────────────────────
  function rIntent() {
    return `<div class="screen"><div class="qwrap">
  <div class="qhead">
    <span class="qlabel">Panty Sizing</span>
    <h2 class="qtitle">Find your<br>panty size</h2>
  </div>
  <div class="sgrid">
    <div class="scard" onclick="window.jnPSM.goTo('panty_direct')">
      <div class="scard-icon">&#10003;</div>
      <div class="scard-title">I know my size</div>
      <div class="scard-desc">Select your size and save it to your fit profile</div>
    </div>
    <div class="scard" onclick="window.jnPSM.goTo('panty_waist')">
      <div class="scard-icon">&#128207;</div>
      <div class="scard-title">Help me find my size</div>
      <div class="scard-desc">Measure your waist and hips and we'll calculate your perfect size</div>
    </div>
  </div>
  <div class="qnav">${backBtn()}</div>
</div></div>`;
  }

  function rDirect() {
    const sizes = ['XS','S','M','L','XL','XXL'];
    const sel = S.pantySize, ok = !!sel;
    return `<div class="screen"><div class="fwrap">
  <span class="qlabel">Panty Sizing</span>
  <h2 class="qtitle">Select your size</h2>
  <p class="qsub">Choose your panty size to save it to your fit profile.</p>
  <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;max-width:320px;margin:28px auto 0">
    ${sizes.map(sz => `<div class="scard ${sel===sz?'sel':''}" style="padding:20px 10px" onclick="window.jnPSM.selectDirect('${sz}')">
      <div style="font-family:'Cormorant Garamond',serif;font-size:22px;font-weight:400">${sz}</div>
    </div>`).join('')}
  </div>
  <div class="qnav">
    ${backBtn()}
    <button class="btn btn-d" id="jpsm-dsbtn" onclick="window.jnPSM.confirmDirect()" ${ok?'':'disabled'} style="${ok?'':'opacity:.35;cursor:not-allowed'}">Save My Size &nbsp;&#8594;</button>
  </div>
</div></div>`;
  }

  function rWaist() {
    const isCm = S.unit === 'cm', ok = !!S.waistIn;
    return `<div class="screen"><div class="fpage">
  <div class="fside-l">
    <span class="qlabel">Step 1 of 2 — Waist Measurement</span>
    <h2 class="qtitle">Measure your<br>waist</h2>
    <div class="utog">
      <button class="ubtn ${!isCm?'on':''}" onclick="window.jnPSM.setUnit('in')">Inches</button>
      <button class="ubtn ${isCm?'on':''}" onclick="window.jnPSM.setUnit('cm')">CM</button>
    </div>
    <div class="minp-g">
      <label class="minp-l">Your measurement</label>
      <input class="minp" type="number" id="jpsm-wi" value="${S.waistIn}" placeholder="${isCm?'69':'27'}" step="0.5" min="18" max="55" oninput="window.jnPSM.onWaistInput(this.value)">
      <div class="munit">${isCm?'centimetres':'inches'}</div>
    </div>
    <div class="qnav">
      ${backBtn()}
      <button class="btn btn-d" id="jpsm-wnxt" onclick="window.jnPSM.goTo('panty_hip')" ${ok?'':'disabled'} style="${ok?'':'opacity:.35;cursor:not-allowed'}">Next &nbsp;&#8594;</button>
    </div>
  </div>
  <div class="fside-r">
    <div class="fimg-wrap">
      <img class="fillus" src="https://cdn.shopify.com/s/files/1/1658/2831/files/waist-measure.png?v=1781727114&width=600" alt="Waist measurement illustration">
      <div class="fimg-cap">
        <div class="fimg-cap-label">Fitter's Notes</div>
        <div class="fimg-cap-quote">"Wrap the tape around your natural waist — the narrowest part of your torso, usually just above your belly button."</div>
      </div>
    </div>
  </div>
</div></div>`;
  }

  function rHip() {
    const isCm = S.unit === 'cm', ok = !!S.hipIn;
    return `<div class="screen"><div class="fpage">
  <div class="fside-l">
    <span class="qlabel">Step 2 of 2 — Hip Measurement</span>
    <h2 class="qtitle">Now measure<br>your hips</h2>
    <div class="utog">
      <button class="ubtn ${!isCm?'on':''}" onclick="window.jnPSM.setUnit('in')">Inches</button>
      <button class="ubtn ${isCm?'on':''}" onclick="window.jnPSM.setUnit('cm')">CM</button>
    </div>
    <div class="minp-g">
      <label class="minp-l">Your measurement</label>
      <input class="minp" type="number" id="jpsm-hi" value="${S.hipIn}" placeholder="${isCm?'96':'38'}" step="0.5" min="24" max="65" oninput="window.jnPSM.onHipInput(this.value)">
      <div class="munit">${isCm?'centimetres':'inches'}</div>
    </div>
    <div class="qnav">
      ${backBtn()}
      <button class="btn btn-d" id="jpsm-hnxt" onclick="window.jnPSM.doCalc()" ${ok?'':'disabled'} style="${ok?'':'opacity:.35;cursor:not-allowed'}">Calculate My Size &nbsp;&#8594;</button>
    </div>
  </div>
  <div class="fside-r">
    <div class="fimg-wrap">
      <img class="fillus" src="https://cdn.shopify.com/s/files/1/1658/2831/files/hips-measure.png?v=1781727069&width=600" alt="Hip measurement illustration">
      <div class="fimg-cap">
        <div class="fimg-cap-label">Fitter's Notes</div>
        <div class="fimg-cap-quote">"Wrap the tape around the fullest part of your hips and seat, usually about 7–9 inches below your natural waist."</div>
      </div>
    </div>
  </div>
</div></div>`;
  }

  function rResult() {
    const sz = S.pantySize, ds = S.dressSize;
    const sisters = getSisterSizes(sz);
    return `<div class="screen"><div class="fwrap">
  <span class="qlabel">Your Size Result</span>
  <h2 class="qtitle">Your size is</h2>
  <div class="szdisp">${sz}</div>
  <p class="szbreak">Based on US dress size <strong>${ds}</strong></p>
  ${sisters.length ? `<p class="sislbl">Neighbouring sizes</p><div class="sispills">${sisters.map(s=>`<span class="sispill">${s}</span>`).join('')}</div>` : ''}
  <div class="fnote">
    <div class="fnote-label">Fitter's Notes</div>
    <div class="fnote-quote">"Your measurements suggest a size ${sz}. If you're between sizes, we recommend sizing up for comfort."</div>
  </div>
  <div class="qnav">
    <button class="btn btn-d" onclick="window.jnPSM.closeModal()">Apply this size &nbsp;&#8594;</button>
  </div>
</div></div>`;
  }

  // ── ACTIONS ──────────────────────────────────────────────────────────────────
  function selectDirect(sz) { S.pantySize = sz; render(); }

  function confirmDirect() {
    if (!S.pantySize) return;
    savePantySize(null, S.pantySize);
    closeModal();
  }

  function onWaistInput(v) { S.waistIn = v; tog('jpsm-wnxt', !!v); }
  function onHipInput(v)   { S.hipIn   = v; tog('jpsm-hnxt', !!v); }

  function setUnit(u) {
    const wEl = document.getElementById('jpsm-wi');
    const hEl = document.getElementById('jpsm-hi');
    if (wEl) S.waistIn = wEl.value;
    if (hEl) S.hipIn   = hEl.value;
    S.unit = u;
    render();
  }

  function doCalc() {
    if (!S.hipIn) return;
    let waistIn = parseFloat(S.waistIn || '0'), hipIn = parseFloat(S.hipIn);
    if (S.unit === 'cm') { waistIn /= 2.54; hipIn /= 2.54; }
    const dressSize = calcDressFromWaistHip(waistIn, hipIn);
    const pantySize = DRESS_TO_PANTY[dressSize] || 'M';
    S.pantySize = pantySize;
    S.dressSize = dressSize;
    savePantySize(dressSize, pantySize);
    goTo('panty_result');
  }

  // ── RENDER ───────────────────────────────────────────────────────────────────
  function screenHTML() {
    if (S.screen === 'panty_direct') return rDirect();
    if (S.screen === 'panty_waist')  return rWaist();
    if (S.screen === 'panty_hip')    return rHip();
    if (S.screen === 'panty_result') return rResult();
    return rIntent();
  }

  function render() {
    const app = document.getElementById('jn-psm-app');
    if (!app) return;
    app.innerHTML = screenHTML();
    const prog = document.getElementById('jn-psm-prog');
    if (prog) prog.style.width = (PROGRESS[S.screen] || 0) + '%';
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const sc = app.querySelector('.screen');
      if (sc) sc.classList.add('active');
    }));
  }

  // ── MODAL DOM ────────────────────────────────────────────────────────────────
  let overlay = null;

  function injectCSS() {
    if (!document.getElementById('jn-psm-overlay-style')) {
      const st = document.createElement('style');
      st.id = 'jn-psm-overlay-style';
      st.textContent = OVERLAY_CSS;
      document.head.appendChild(st);
    }
    // Inject shared panel CSS only if bra modal hasn't already done so
    if (!document.getElementById('jn-bsm-style')) {
      const st = document.createElement('style');
      st.id = 'jn-bsm-style';
      st.textContent = PANEL_CSS;
      document.head.appendChild(st);
    }
  }

  function ensureFonts() {
    if (!document.getElementById('jn-bsm-fonts') && !document.getElementById('jn-psm-fonts')) {
      const link = document.createElement('link');
      link.id = 'jn-psm-fonts';
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=Inter:wght@300;400;500;600&display=swap';
      document.head.appendChild(link);
    }
  }

  function openModal() {
    if (overlay) return;
    ensureFonts();
    injectCSS();

    S = { screen:'panty_intent', history:['panty_intent'], unit:'in', waistIn:'', hipIn:'', pantySize:null, dressSize:null };

    overlay = document.createElement('dialog');
    overlay.className = 'jn-psm-overlay';
    overlay.setAttribute('aria-label', 'Find your panty size');
    overlay.innerHTML = `<div class="jn-bsm" id="jn-psm-panel">
  <div class="jn-bsm-prog" id="jn-psm-prog" style="width:0%"></div>
  <button class="jn-bsm-close" onclick="window.jnPSM.closeModal()" aria-label="Close">&#10005;</button>
  <div id="jn-psm-app"></div>
</div>`;

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    overlay.showModal();

    // Force full-viewport coverage — iOS Safari UA dialog styles resist CSS class overrides
    overlay.style.setProperty('position', 'fixed', 'important');
    overlay.style.setProperty('inset', '0', 'important');
    overlay.style.setProperty('width', '100%', 'important');
    overlay.style.setProperty('height', '100%', 'important');
    overlay.style.setProperty('max-width', 'none', 'important');
    overlay.style.setProperty('max-height', 'none', 'important');
    overlay.style.setProperty('padding', '0', 'important');
    overlay.style.setProperty('border', 'none', 'important');
    overlay.style.setProperty('margin', '0', 'important');

    // Intercept native Escape-key close so our animation and event fire correctly
    overlay.addEventListener('cancel', function(e) { e.preventDefault(); closeModal(); });
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });

    render();
    requestAnimationFrame(() => overlay.classList.add('open'));
  }

  function closeModal() {
    if (!overlay) return;
    const el = overlay;
    overlay = null;
    el.classList.remove('open');
    setTimeout(function() {
      document.body.style.overflow = '';
      el.close();
      if (el.parentNode) el.parentNode.removeChild(el);
      document.dispatchEvent(new CustomEvent('jnPantySizeSet', { bubbles: true }));
    }, 300);
  }

  // ── PUBLIC API ───────────────────────────────────────────────────────────────
  window.jnPSM = { openModal, closeModal, goTo, goBack, selectDirect, confirmDirect, doCalc, setUnit, onWaistInput, onHipInput };
  window.jnOpenPantyModal = openModal;

})();
